import { makeAutoObservable, runInAction } from 'mobx';
import { toast } from 'react-toastify';
import agent from '../api/agent';
import { store } from './store';
import { Activity } from '../models/activity';
import { subtaskKanbanOptions } from '../common/options/otherOptions/accessOptions';
import { historyPayloadType, updateHistoryMain } from '../models/history';
import { ReelInformation } from '../../features/MediaAssets/Sections/Nfai_AV_SyncUpload';
export default class ReportStore {
  constructor() {
    makeAutoObservable(this);
  }

  KanbanArray: any[] = [];
  HFCallocateItemToUserArray: string[] = [];
  scanData: any[] = [];
  HFCCheck: boolean = false;
  KanbanItemId: any = '';
  isCheckAll: {
    checked: boolean;
    activePage: number;
  } = {
    checked: false,
    activePage: 1,
  };
  isCheckAllScanned: {
    checked: boolean;
    activePage: number;
  } = {
    checked: false,
    activePage: 1,
  };
  createSingleDepartmentName: string[] = [];
  selectAllClicked: boolean = false;
  selectAllClickedScan: boolean = false;
  userIdOfSelectedItem: string[] = [];
  AllocateUserDDValue: string[] = [];
  removeUserDDvalue: string[] = [];
  AU_department: string = '';

  totalPivotCount = 0;
  increaseCount = 0;
  LinkExsitingArray: string[] = [];
  LinkExsitingChecker: string[] = [];
  ismasterTitle: string = '';
  assetTrackingReportData: any[] = [];
  NFAIReportCutlistPreviewList: any[] = [];
  //myDATA

  dataCheckbox = (activityId: any) => {
    try {
      this.LinkExsitingArray?.forEach(async (item) => {
        await agent.Reports.ExistingLink(item, activityId);
        const payload: historyPayloadType = {
          taskId: '',
          taskName: '',
          subTaskId: '',
          subTaskName: '',
          status: `${this.HistoryLinksection} asset is linked successfully through Link Existing`,
          date: new Date(),
        };
        updateHistoryMain(payload, false, true);
      });

      toast.success('Linked successfully');
    } catch (error) {
      console.log(error, 'error');
      toast.error('Cannot Link Item');
    }
  };

  //For Metadata

  // Meta Data - Variable Declaration

  metaDataRegistry = new Map<string, any>();
  metadataNoPaginationRegistry = new Map<string, any>();

  metaDataNoPaginationReport: string[] = [
    'id',
    'title',
    'type',
    'element',
    'asset_tracking_status',
    'physical_sensor_qrcode',
    'physical_sensor_barcode',
    'originindia',
    'year',
    'language',
  ];
  metaDataHeaders = [];
  loadingDataReport = false;
  loadingMetaDataReport = false;
  loadingkanbanData = false;
  metaDataCount = 0;
  // KanbanArray: any[] = [];
  // KanbanItemId:any='';
  totalMetaDataCount = 0;
  // loadingkanbanData=false;
  openMetaDataReportModal = false;
  // hideProgressBarMetaDataModal=true;
  totalCountReportModal = 0;
  loadCountReportModal = 0;
  loadMetadataReportComponent = false;
  allocateItemToUserArray: string[] = [];
  allocateScannedItemToUserArray: string[] = [];
  LinkExsitingRefresh: boolean = false;
  HistoryLinksection: string = '';
  HfcMoveToVaultScan:boolean = false;

  AllocateUserPageNumber: number = 1;
  // loadMetadataReportComponent=false;
  // loadCountReportModal=0;
  // hideProgressBarMetaDataModal=false;
  get metaDataPaginationAll() {
    return Array.from(this.metaDataRegistry.values());
  }
  get metaDataNoPagination() {
    return Array.from(this.metadataNoPaginationRegistry.values());
  }
  private setReports = (activity: any) => {
    this.metaDataRegistry.set(activity.id, activity);
  };

  private setMetaDataNoPaginationReports = (activity: any) => {
    this.metadataNoPaginationRegistry.set(activity.id, activity);
  };

  setOpenMetaDataReportModal = (data: boolean) => {
    this.openMetaDataReportModal = data;
  };
  
  //For Metadata
  loadReportPagination = async (
    pagenumber: number,
    data: string[],
    name: string,
  ) => {
    this.loadingDataReport = true;
    try {
      const activities: any =
        store.userStore.user?.customerName !== 'LVPCMS'
          ? await agent.Reports.reportsWithPaginationPost(
              pagenumber,
              name === 'SmartTracker' ? 20 : 10,
              data,
            )
          : await agent.Reports.loadNotFilmFestivalPagination(pagenumber);
      if (pagenumber === 1) {
        let params = {
          itemlevelBody: null,
          PageNumber: pagenumber,
          PageSize: name === 'SmartTracker' ? 20 : 10,
        };
        let titles = localStorage.getItem(name)?.split(',');
        const loadCount = await agent.Reports.searchListCount(params, titles);
        if (typeof loadCount?.data === 'string') {
          store.dashboardStore.dashboard.inventoryCount2 = 0;
        } else {
          store.dashboardStore.dashboard.inventoryCount2 = loadCount?.data || 0;
        }
        store.dashboardStore.dashboard.setRegisterPageNumber = 1;
        store.dashboardStore.dashboard.setReportsPageNum = 1;
        store.dashboardStore.setReportsPageNum(1);
      }
      const data1 = activities.data?.replace(',}}', '}')?.replace('}}', '}');
      const parsedData: any =
        store.userStore.user?.customerName !== 'LVPCMS'
          ? JSON.parse(data1)
          : activities;
      this.metaDataRegistry = new Map<string, any>();
      runInAction(() => {
        parsedData.forEach((activity: any) => {
          this.setReports(activity);
        });
      });
      this.loadingDataReport = false;
    } catch (error) {
      console.log(error);
      this.loadingDataReport = false;
    }
  };
  //For Metadata
  // loadMetaDataReportWithoutPagination = async(data:string[])=>{
  //        this.loadingMetaDataReport=true;
  //        try
  //        {      let response = await agent.Reports.loadTotalMetaDataCount();
  //               let AsyncCallLength = Math.ceil(parseInt(response.slice(20))/25);
  //               this.totalMetaDataCount=parseInt(response.slice(20));
  //               for(let i=1;i<=AsyncCallLength;i++){
  //                      // if(data.includes(',')) {
  //                             const activities = await agent.Reports.MetaDataWithoutPagination(i,25,data);
  //                             if(activities.data!=="Item Not Found"){
  //                                    const parsedData  =   JSON.parse(activities.data);
  //                                    runInAction(() => {
  //                                                  Array.prototype.push.apply(this.metaDataNoPaginationReport,parsedData);
  //                                    });
  //                              }
  //                              this.metaDataCount+=25;
  //               }
  //            this.loadingMetaDataReport=false;
  //        }
  //        catch(error)
  //        {
  //               this.loadingMetaDataReport=false;
  //                console.log(error);
  //        }
  // }
  loadMetaDataStoredHeaders = async () => {
    try {
      let response = await agent.Reports.metadataReportKeys(
        store.userStore.user?.customerName!,
      );
      response.forEach((element) => {
        if (!this.metaDataNoPaginationReport.includes(element)) {
          this.metaDataNoPaginationReport.push(element);
        }
      });
    } catch (err) {
      console.log(err);
    }
  };

  searchMetaDataReport = async (
    pagenumber: number,
    data: any,
    selectedColumns: any,
    name?: string,
) => {
    this.loadMetadataReportComponent = true;
    try {
        let filteredData = Object.fromEntries(
            Object.entries(data).filter(([_, v]) => v !== '')
        );

        let paramsItems = {
            itemlevelBody: JSON.stringify(filteredData),
            PageNumber: pagenumber,
            PageSize: name === 'SmartTracker' ? 20 : 10,
        };
        const search = async () => {
          const params = {
            taskName: filteredData?.current_task || "",
            subtaskName: filteredData?.current_subtask || "",
            titleCode: filteredData?.['metadata/ title_code'] || "",
            pLName: filteredData?.['metadata/ pl_name'] || "",
            empName: filteredData?.['metadata/ displayname'] ||
              (store.userStore.user?.roleName !== 'Resto Admin' &&
                !store.commonStore.filterModeOne.includes('GA01') && store?.userStore?.user?.displayName) || "",
          };
        
          return (name === 'SmartTracker') ?
            await agent.Reports.smarttrackerSearchListPost(pagenumber, params) :
            await agent.Reports.searchListPost(paramsItems, selectedColumns);
        };
        
        const count = async () => {
          const params = {
            taskName: filteredData?.current_task || "",
            subtaskName: filteredData?.current_subtask || "",
            titleCode: filteredData?.['metadata/ title_code'] || "",
            pLName: filteredData?.['metadata/ pl_name'] || "",
            empName: filteredData?.['metadata/ displayname'] ||
              (store.userStore.user?.roleName !== 'Resto Admin' &&
                !store.commonStore.filterModeOne.includes('GA01') && store?.userStore?.user?.displayName) || "",
          };
        
          return (name === 'SmartTracker') ?
            await agent.Reports.smarttrackerSearchListCount(params) :
            await agent.Reports.searchListCount(paramsItems, selectedColumns);
        };

        let [worklevels, loadCount] = await Promise.all([search(), count()]);
        if (pagenumber === 1) {
            store.dashboardStore.dashboard.setRegisterPageNumber = 1;
            store.dashboardStore.dashboard.setReportsPageNum = 1;
            store.dashboardStore.setReportsPageNum(1);
        }

        this.metaDataRegistry = new Map<string, any>();
        if (worklevels.data === 'Item Not found') {
            store.dashboardStore.dashboard.inventoryCount2 = 0;
        } else if (worklevels?.data.length) {
            // const data1 = worklevels.data.replace(',}}', '}').replace('}}', '}').replaceAll('"]', '"}]');
            let resp = name === 'SmartTracker' ? worklevels?.data : worklevels.data?.replace(',}}', '}').replace('}}', '}')?.replaceAll('"]', '"}]');
            if (name === 'SmartTracker') {
              this.metaDataRegistry = new Map<string, any>();
              const currentUser = store?.userStore?.user?.displayName;
              if (
                currentUser &&
                store.userStore.user?.roleName !== 'Quality Check' &&
                store.userStore.user?.roleName !== 'Resto Admin' &&
                store.userStore.user?.roleName!=='QC'&&
                !store?.commonStore?.filterModeOne?.includes('GA01') 
              ) {
                resp = resp?.filter((item: any) => {
                  const displayNameIndex = item?.metadata?.findIndex((item: any) => item?.elementName === 'Displayname');
                  return displayNameIndex !== -1 &&
                    item?.metadata[displayNameIndex]?.elementValue.trim() === currentUser.trim();
                });
              }
              if (data?.current_subtask === 'Dust Busting') {
                resp = resp?.filter((item: any) => item?.current_subtask === 'Dust Busting');
              }
              if (data?.current_user === 'Boopathi') {
                resp = resp?.filter((item: any) => item?.current_user === 'Boopathi');
              }// filteredResp is the modified array with filtered metadata
            }
            
            runInAction(() => {
              if(name === 'SmartTracker'){
                const keysToExtract = [
                  'title_code',
                  'reel_name',
                  'shot_name',
                  'resolution',
                  'start_frame',
                  'end_frame',
                  'total_frame',
                  'team',
                  'pl_name',
                  'displayname',
                  'employee name',
                  'current_task',
                  'current_subtask',
                  'assetcondition',
                  'status',
                  'physical_location_rack',
                  'physical_location_shelf',
                  'physical_location_vault',
                  'input path',
                  'output path',
              ];
              const extractedData = resp?.map((element: any) => {
                  const extractedObject: any = {};
              
                  element?.metadata?.forEach((values: any) => {
                      keysToExtract?.forEach((item: any) => {
                          if (values?.elementName?.toLowerCase() === item?.toLowerCase() && item !== 'displayname' && item !== 'Locked By') {
                              extractedObject[item?.replaceAll(/ /g, '_')] = values.elementValue?.replaceAll(/ /g, '_');
                          }
                          else{
                            if(values?.elementName?.toLowerCase() === item?.toLowerCase()){
                              extractedObject[item] = values?.elementValue;
                            }
                          }
                      });
                  });
                  Object.entries(element).forEach(([key, value]: [string, any]) => {
                      keysToExtract?.forEach((item: any) => {
                          if (key?.toLowerCase() === item?.toLowerCase()) {
                              extractedObject[item?.replaceAll(/ /g, '_')] = (value as string)?.replaceAll(/ /g, '_'); // Type assertion to string
                          }
                      });
                  });
              
                  extractedObject['id'] = element?.id; // Assuming 'id' is the property name you want to use
                  return extractedObject;
              });
              const replaceString = {
                'assetcondition':'titleStatus',	
                'physical_location_rack':'Locked By',
                'physical_location_shelf' :'previous owner employeeId',
                 'physical_location_vault' : 'previous owner name'
              }
             // Assuming extractedData and replaceString are properly typed elsewhere in your code
                const modifiedData = extractedData?.map((obj: any) => {
                  return Object.fromEntries(
                      Object.entries(obj).map(([key, value]: [string, any]) => {
                          const newKey = replaceString[key as keyof typeof replaceString] || key;
                          return [newKey, value];
                      })
                  );
                });
                store.dashboardStore.dashboard.inventoryCount2 = loadCount.data;
                modifiedData.forEach((data: any) => {
                    this.setReports(data);
                });
              }
              else{
                store.dashboardStore.dashboard.inventoryCount2 = loadCount.data;
                try {
                  const parsedVaule = JSON.parse(resp)
                  parsedVaule.forEach((data: any) => {
                      this.setReports(data);
                  });
                } catch (error) {
                  toast.error('Something went wrong !');
                  console.log(error)
                }
              }
        
            });
        } else {
            store.dashboardStore.dashboard.inventoryCount2 = 0;
        }
        this.loadMetadataReportComponent = false;
        if(name === 'SmartTracker') store.TrackingReportStore.bindComponent.loader = false;
    } catch (error) {
        this.loadMetadataReportComponent = false;
        if(name === 'SmartTracker') store.TrackingReportStore.bindComponent.loader = false;
        console.error(error);
    }
};

  sortMetaDataReport = async (
    data: string,
    direction: string,
    pagenum: number,
    selectedData: string[],
  ) => {
    try {
      this.loadMetadataReportComponent = true;
      this.metaDataRegistry = new Map<string, any>();
      const worklevels = await agent.Reports.sortMetaDataReport(
        data,
        direction,
        pagenum,
        selectedData,
      );
      const resp = JSON.parse(worklevels.data);
      runInAction(() => {
        resp.forEach((data: any) => {
          this.setReports(data);
          // this.isActivity = true;
        });
      });
      this.loadMetadataReportComponent = false;
    } catch (err) {
      this.loadMetadataReportComponent = false;
      console.log(err);
    }
  };

  //Film Festival

  filmFestialAll = new Map<string, Activity>();
  onlyFilmFestivall = new Map<string, any>();

  private setFilmActivity = (activity: Activity) => {
    this.filmFestialAll.set(activity.id, activity);
  };
  private setFilmActivityOnly = (activity: any) => {
    this.onlyFilmFestivall.set(activity.itemId, activity);
  };

  get filmFestivalByDate() {
    return Array.from(this.filmFestialAll.values());
  }
  get filmFestivalOnlyByDate() {
    return Array.from(this.onlyFilmFestivall.values());
  }

  loadFilmFestivalPagination = async (pagenumber: number) => {
    try {
      this.filmFestialAll = new Map<string, Activity>();
      // this.activityRegistry=  new Map <string, Activity>();
      const activities =
        await agent.Reports.loadFilmFestivalPagination(pagenumber);

      runInAction(() => {
        activities.forEach((activity) => {
          this.setFilmActivity(activity);
          // this.isActivity = true;
        });
      });
    } catch (error) {
      console.log(error);
      //      this.setLoadingInitial(false);
    }
  };
  searchListFF = async (pagenumber: number, data: any) => {
    try {
      const activities = await agent.Activities.searchListFF(pagenumber, data);
      const resp = activities.data;
      this.filmFestialAll = new Map<string, Activity>();
      runInAction(() => {
        resp.forEach((activity) => {
          this.setFilmActivity(activity);
          // this.isActivity = true;
        });
      });
    } catch (error) {
      console.log(error);
      //  this.setLoadingInitial(false);
    }
  };
  sortListItemsFF = async (data: any, order: string, pagenum: number) => {
    try {
      const activities = await agent.Activities.sortFFList(
        data,
        order,
        pagenum,
      );
      this.filmFestialAll = new Map<string, Activity>();
      runInAction(() => {
        activities.forEach((activity) => {
          this.setFilmActivity(activity);
        });
      });
    } catch (error) {
      console.log(error);
      //  this.setLoadingInitial(false);
    }
  };
  //load Existing Data
  loadExistingData = async (id: string) => {
    try {
      const activities = await agent.Reports.loadFFReport(id);
      this.onlyFilmFestivall = new Map<string, any>();
      runInAction(() => {
        activities.forEach((activity: any) => {
          this.setFilmActivityOnly(activity);
          // this.isActivity = true;
        });
      });
    } catch (err) {}
  };
  linkExistingHoldingArray = async (item: any) => {
    if (!this.LinkExsitingArray.includes(item)) {
      this.LinkExsitingArray.push(item);
    } else {
      this.LinkExsitingArray = this.LinkExsitingArray.filter(
        (data) => data !== item,
      );
    }
  };

  SectionRemoveLink = async (itemId: string, query: string, id: string) => {
    try {
      await agent.Reports.sectionRemoveLink(itemId, query, id);

      toast.success('Item is Deleted Successfully');
    } catch (error) {
      console.log(error);
      toast.error('Failed to Remove');
    }
  };

  findStatusData = (data: number) => {
    return subtaskKanbanOptions[data];
  };

  getUserIdByItemIdAllocate = async (itemId: string[]) => {
    try {
      if (itemId.length > 0) {
        const userId = await agent.Account.getUserIdByItemIdAllocate(
          JSON.parse(JSON.stringify(itemId)),
        );
        runInAction(() => (this.userIdOfSelectedItem = userId.data));
      }
    } catch {
      toast.error('Unexpected Error');
    }
  };
  ScannedItemsCheckAll = (
    data: any,
    dataField: any,
    pageNumData: number = 1,
  ) => {
    this.isCheckAllScanned = {
      checked: !this.isCheckAllScanned.checked,
      activePage: pageNumData,
    };
    this.getAllIdFromScanSelectCheckBox(data, dataField.checked);
  };

  checkBoxCheckedAll = async(ItemData: any, dataField: any, pageNumData: number) => {
    this.isCheckAll = {
      checked: !this.isCheckAll.checked,
      activePage: pageNumData,
    };
    if(!store.commonStore.hfcCustomerChanges) { 
    this.getAllIdFromSelectCheckBox(ItemData, dataField.checked);
    }else{
      if(dataField.checked){
        this.HFCallocateItemToUserArray = ItemData
      }else{
        this.HFCallocateItemToUserArray =[]
      }
      const response = await agent.HFC.HFCscanAssetBarcodes([ItemData[0].asset_Id]);
      runInAction(() => {
        this.scanData = response.data.map((item:any)=>{
          return{
            key:item,
            value:item,
            text:item
          }
        });
      });
      }
  };

  ScannedAllocateUserData = (
    pageData: any,
    rowData: any,
    pageNumData: number = 1,
  ) => {
    if (this.selectAllClickedScan) {
      this.isCheckAllScanned = {
        checked: !this.isCheckAllScanned.checked,
        activePage: pageNumData,
      };
      this.allocateScannedItemToUserArray = [];
      pageData.forEach((datum: { id: string }) => {
        this.allocateScannedItemToUserArray.push(datum.id);
      });
      this.allocateScannedItemToUserArray =
        this.allocateScannedItemToUserArray.filter(
          (data: string) => data !== rowData.id,
        );
      this.selectAllClickedScan = false;
    } else {
      if (!this.allocateScannedItemToUserArray.includes(rowData.id)) {
        this.allocateScannedItemToUserArray.push(rowData.id);
      } else {
        this.allocateScannedItemToUserArray =
          this.allocateScannedItemToUserArray.filter(
            (data: string) => data !== rowData.id,
          );
      }
    }
    this.getUserIdByItemIdAllocate(this.allocateScannedItemToUserArray);
  };
  AllocateUserData = (pageData: any, rowData: any, pageNumData: number) => {
    if (this.selectAllClicked) {
      this.isCheckAll = {
        checked: !this.isCheckAll.checked,
        activePage: pageNumData,
      };
      this.allocateItemToUserArray = [];
      pageData.forEach((datum: { id: string }) => {
        this.allocateItemToUserArray.push(datum.id);
      });
      this.allocateItemToUserArray = this.allocateItemToUserArray.filter(
        (data: string) => data !== rowData.id,
      );
      this.selectAllClicked = false;
    } else {
      if (!this.allocateItemToUserArray.includes(rowData.id)) {
        this.allocateItemToUserArray.push(rowData.id);
      } else {
        this.allocateItemToUserArray = this.allocateItemToUserArray.filter(
          (data: string) => data !== rowData.id,
        );
      }
    }
    this.getUserIdByItemIdAllocate(this.allocateItemToUserArray);
  };

  HFCCheckboxHandler =  async (data: any) => {
    if(this.isCheckAll.checked){
      toast.error(`Please uncheck the "Select All" box to choose specific items.`)
      return
    }
    try {
        const itemIndex = this.HFCallocateItemToUserArray.findIndex((item: any) => item.id === data.id);

        if (itemIndex > -1) {
            // Item is already in the array, remove it
            this.HFCallocateItemToUserArray.splice(itemIndex, 1);
        } else {
            // Item is not in the array, add it
            this.HFCallocateItemToUserArray.push(data);
        }
        const containerBarcodes = this.HFCallocateItemToUserArray.map((item: any) => item.container_Barcodes);
        
        // Make the API call and store the response
        const response = await agent.HFC.HFCscanAssetBarcodes(containerBarcodes);
        
        // Store the response in a store variable
        runInAction(() => {
          this.scanData = response.data.map((item:any)=>{
            return{
              key:item,
              value:item,
              text:item
            }
          });
        }); 
    } catch (error) {
        // Handle errors
        console.error('Error:', error);
    }
}


  RemoveUser = async (tableName: string) => {
    try {
      let arr = [];
      let userList = this.removeUserDDvalue;
      if (tableName === 'AllocateUser') {
        arr = this.allocateItemToUserArray;
      } else {
        arr = this.allocateScannedItemToUserArray;
      }
      arr?.forEach(async (itemId) => {
        const response =
          await agent.Reports.RemoveMultipleUserFromMultipleItems(
            itemId,
            this.removeUserDDvalue,
          );
        if (response.data !== '') {
          userList?.forEach(async (userId: string) => {
            const user = store.userStore.getUsers?.filter(
              (user) => user.id === userId,
            );
            await store.commonStore.updateHistoryAlonePOST(
              `${response?.data} is removed successfully from user ${user[0]
                ?.displayName} by ${store.userStore.user?.displayName!}`,
              itemId,
              undefined,
              false,
              true,
            );
          });
        }
      });
      this.allocateItemToUserArray = [];
      this.allocateScannedItemToUserArray = [];
      this.isCheckAll = {
        checked: false,
        activePage: 1,
      };
      this.isCheckAllScanned = {
        checked: false,
        activePage: 1,
      };
      this.removeUserDDvalue = [];
      toast.success('User removed successfully');
      toast.success('History updated successfully');
    } catch {
      toast.error('Unable to remove user, please try again !');
    }
  };

  AllocateCheckbox = (tableName: string) => {
    try {
      let arr = [];
      let userList = this.AllocateUserDDValue;
      if (tableName === 'AllocateUser') {
        arr = this.allocateItemToUserArray;
      } else {
        arr = this.allocateScannedItemToUserArray;
      }
      arr?.forEach(async (item) => {
        if (store.clonedStore.userItems.includes(item))
          return toast.error('User already assigned.');
        const response = await agent.Reports.AllocateMultipleItemToMultipleUser(
          item,
          this.AllocateUserDDValue,
        ); //assign a user
        if (response.data !== '') {
          userList?.forEach(async (userId: string) => {
            const user = store.userStore.getUsers?.filter(
              (user) => user.id === userId,
            );
            await store.commonStore.updateHistoryAlonePOST(
              `${response?.data} is allocated successfully to user ${user[0]
                ?.displayName} by ${store.userStore.user?.displayName!}`,
              item,
              undefined,
              false,
              true,
            );
          });
        }
      });
      this.allocateItemToUserArray = [];
      this.allocateScannedItemToUserArray = [];
      this.isCheckAll = {
        checked: false,
        activePage: 1,
      };
      this.isCheckAllScanned = {
        checked: false,
        activePage: 1,
      };
      this.AllocateUserDDValue = [];
      toast.success('User Allocated successfully');
      toast.success('History updated successfully');
    } catch {
      toast.error('User not allocated. Please try again !');
    }
  };
  ArrayData = async (item: any) => {
    if (!this.LinkExsitingArray.includes(item)) {
      this.LinkExsitingArray.push(item);
    } else {
      this.LinkExsitingArray = this.LinkExsitingArray.filter(
        (data) => data !== item,
      );
    }
  };
  LinkExistingConnect = async (data: boolean) => {
    this.LinkExsitingRefresh = data;
  };
  ///get all IDs from select All
  getAllIdFromSelectCheckBox = (ItemData: Activity[], dataField: boolean) => {
    if (ItemData && dataField) {
      ItemData.forEach((item) => {
        this.allocateItemToUserArray.push(item.id);
      });
      this.selectAllClicked = true;
    } else {
      ItemData.forEach((item) => {
        if (this.allocateItemToUserArray.includes(item.id)) {
          this.allocateItemToUserArray = this.allocateItemToUserArray.filter(
            (data: string) => data !== item.id,
          );
        }
      });
      // this.allocateItemToUserArray = this.allocateItemToUserArray.filter((data: string) => data !== rowData.id);
      // this.allocateItemToUserArray=[];
      if (this.allocateItemToUserArray.length === 0) {
        this.selectAllClicked = false;
      }
    }
    this.getUserIdByItemIdAllocate(this.allocateItemToUserArray);
  };

  getAllIdFromHFCSelectCheckBox = (ItemData: any, dataField: boolean) => {
    if (dataField) {
      this.HFCallocateItemToUserArray = ItemData
    } else {
      this.HFCallocateItemToUserArray =[]
    }
  };
  getAllIdFromScanSelectCheckBox = (data: Activity[], dataField: boolean) => {
    if (data && dataField) {
      data.forEach((item) => {
        this.allocateScannedItemToUserArray.push(item.id);
      });
      this.selectAllClickedScan = true;
    } else {
      data.forEach((item) => {
        if (this.allocateScannedItemToUserArray.includes(item.id)) {
          this.allocateScannedItemToUserArray =
            this.allocateScannedItemToUserArray.filter(
              (scannedData: string) => scannedData !== item.id,
            );
        }
      });
      if (this.allocateScannedItemToUserArray.length === 0) {
        this.selectAllClickedScan = false;
      }
    }
    this.getUserIdByItemIdAllocate(this.allocateScannedItemToUserArray);
  };

  ismasterTitlechanger = (title: string) => {
    this.ismasterTitle = title;
  };

  AssetTrackingTableData = async (
    workLevel: string,
    pageNumber: number,
    pageSize: number,
  ) => {
    try {
      const response = await agent.AssetTracking.workLevelBasedItems({
        workLevel,
        pageNumber,
        pageSize,
      });
      runInAction(() => {
        this.assetTrackingReportData = response.data;
      });
    } catch {
      toast.error('Something went wrong !');
    }
  };

  reportDataInfo = async (pageNumber: number, pageSize: number) => {
    try {
      const response = await agent.AssetTracking.reportDataInfo({
        pageNumber,
        pageSize,
      });
      return response?.data;
    } catch {
      toast.error('Something went wrong !');
    }
  };

  parentOptionApi = async (pagenum: number, data: any) => {
    this.loadingDataReport = true;
    try {
      const activities = await agent.Reports.postDropdownParentItems(
        pagenum,
        data,
      );

      const parsedData: any = JSON.parse(activities.data);
      if (pagenum === 1) {
        const loadCount = await agent.Reports.postDropdownParentItemsCount();
        if (typeof loadCount?.data === 'string') {
          store.dashboardStore.dashboard.inventoryCount2 = 0;
        } else {
          store.dashboardStore.dashboard.inventoryCount2 = loadCount?.data || 0;
        }
        store.dashboardStore.dashboard.setRegisterPageNumber = 1;
        store.dashboardStore.dashboard.setReportsPageNum = 1;
        store.dashboardStore.setReportsPageNum(1);
      }
      this.metaDataRegistry = new Map<string, any>();
      runInAction(() => {
        parsedData.forEach((activity: any) => {
          this.setReports(activity);
        });
      });

      this.loadingDataReport = false;
    } catch (error) {
      this.loadingDataReport = false;
      console.log(error);
    }
  };

  withoutAllworkflow = () => {
    this.metaDataRegistry = new Map<string, any>();
    store.dashboardStore.dashboard.inventoryCount2 = 0;
  };

  AVSyncParrentDataHandle = async (
    itemId: string,
    params: ReelInformation[],
  ) => {
    try {
      const response = await agent.NFAIReport.AVSyncParrentData(itemId, params);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  AVSyncfromParrentHandler =async(itemId:string)=>{
    try {
        const response = await agent.NFAIReport.AVSyncfromParrent(itemId);
        return response.data;
    } catch (error) {
      console.log(error)
    }
  }
   HandleReelAnalysis = async (itemId:string,path:string,fileName:string) => {
    try {
      await agent.NFAIReport.reelAnalysis(itemId,path,fileName);
    } catch (error) {
      console.log(error)
    }
   }
   HandleCutlistPreivew = async (itemId:string,reelNo:string,startFrame:number,endFrame:number) => {
    try {
    const response =  await agent.NFAIReport.getCutlistPreivew(itemId,reelNo,startFrame,endFrame);
    runInAction(() => {
      this.NFAIReportCutlistPreviewList = response.data;
    })
    } catch (error) {
      console.log(error)
    }
   }
}
